import { useState, useEffect } from "react";
import { getTreeDataV2Api } from "../api/registry.api";
import { headersBuilder } from "../libs/helpers/callApi";

// Simple in-memory cache
const cache = {};

/**
 * Custom hook to fetch tree data (e.g., Sectors, Categories) with rudimentary caching.
 * @param {string} entity - The entity type to fetch tree data for (e.g., 'Sector').
 */
const useTreeData = (entity) => {
  const [data, setData] = useState(cache[entity] || []);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!entity) return;

    if (cache[entity]) {
      setData(cache[entity]);
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);
      try {
        const headers = headersBuilder();
        const response = await getTreeDataV2Api({ headers, entity });
        const treeData = response || [];
        cache[entity] = treeData;
        setData(treeData);
      } catch (err) {
        console.error(`Error loading tree data for ${entity}:`, err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [entity]);

  return { data, loading, error };
};

export default useTreeData;
